import { useValueChangeEffect } from '../useValueChangeEffect';

import { useSearchParams } from './useSearchParams';

export function useSearchParamsChange(callback: () => void) {
	const searchParams = useSearchParams();
	const query = new URLSearchParams([...searchParams.entries()]).toString();

	useValueChangeEffect(query, callback);
}
